import React from "react";
import { FieldRendererProps } from "../types";
import { ErrorMessage } from "../styles";
import SelectBoxSearch from "../../selectboxsearch";

export const SelectFieldRenderer: React.FC<FieldRendererProps> = ({
  campo, modo, getFieldValue, handleInputChange, handleBlur, errors,
}) => (
  <>
    <SelectBoxSearch
      campo={campo}
      modo={modo}
      getFieldValue={getFieldValue}
      handleInputChange={handleInputChange}
      apenasLeitura={campo.apenasLeitura}
      isClearable={campo.selectBoxIsCleareable}
      hint={campo.selectBoxHint}
      onBlur={(value: any) => handleBlur(campo, value)}
      hasError={!!errors[campo.nome]}
      allowNotFoundValues={campo.allowNotFoundValues ?? false}
    />
    {errors[campo.nome] && <ErrorMessage>{errors[campo.nome]}</ErrorMessage>}
  </>
);
